export const makeContactLensPricingColumns = (contactLensTypeLabels = {}) => [
    {
        Header: "Model",
        accessor: "contactLensModel.modelName",
        canFilter: true,
        filterPlaceholder: "Filter by model",
        width: 150,
    },
    {
        Header: "Manufacturer",
        accessor: "contactLensModel.manufacturer.name",
        canFilter: true,
        filterPlaceholder: "Filter by manufacturer",
        width: 140,
    },
    {
        Header: "Material",
        accessor: "contactLensModel.material.name",
        Cell: ({ value }) => value || '—',
        width: 120,
    },
    {
        Header: "Lens Type",
        accessor: "contactLensModel.lensType",
        Cell: ({ value }) => (value ? contactLensTypeLabels[value] || value : '—'),
        canFilter: true,
        filterPlaceholder: "Filter by type",
        width: 120,
    },
    {
        Header: "Schedule",
        accessor: "schedule.name",
        Cell: ({ row }) => {
            const schedule = row.original.schedule;
            if (!schedule) return '—';
            return `${schedule.name} (${schedule.daysSupply} days)`;
        },
        canFilter: true,
        filterPlaceholder: "Filter by schedule",
        width: 140,
    },
    {
        Header: "Lenses/Box",
        accessor: "lensesPerBox",
        width: 90,
    },
    {
        Header: "Box Quantity Range",
        accessor: (row) => {
            const min = row.minBoxQuantity || 1;
            const max = row.maxBoxQuantity;
            return max ? `${min}-${max}` : `${min}+`;
        },
        width: 130,
    },
    // {
    //     Header: "Base Cost",
    //     accessor: "baseCost",
    //     Cell: ({ value }) => `$${parseFloat(value).toFixed(2)}`,
    //     width: 100,
    // },
    {
        Header: "Retail Price",
        accessor: "baseRetailPrice",
        Cell: ({ value }) => `$${parseFloat(value).toFixed(2)}`,
        width: 110,
    },
    {
        Header: "Status",
        accessor: "status",
        canFilter: true,
        filterPlaceholder: "Filter by status",
        width: 80,
    },
];
